export default "__VITE_ASSET__8el18CXL__"